import { hydrate } from '@rune-ts/server';
import { ClientRouter } from '../route';

export const clientHydrate = () => hydrate(ClientRouter);
